import React from 'react'
import { Link } from 'react-router-dom';

import "./Distribution.css"

import Seperator from "../Util/Seperator"
import Logo from "../Util/Logo"

import {ReactComponent as Package} from '../assets/icons/package.svg'
import {ReactComponent as Handshake} from '../assets/icons/handshake.svg'

import {useTranslate} from "../Context/LanguageContext"
import Button from "../Util/Button"


const Distribution = () => {
    const t = useTranslate("distribution")

    return ( 
        <div className='distribution'>

            <section className='start'>
                <img
                    src='./images/distribution.webp'
                    alt=''
                    loading='eager'
                    decoding='async'
                />

                <div className='wrapper'>
                    <h1>{t("heading")}<span> China</span></h1>
                    <p>{t("heading-txt")}</p>
                    <Button to="/contact" filled>{t("contact")}</Button>
                </div>
            </section>

            <section className='quality'>
                <div className='wrapper'>
                    <p className='text'>{t("quality")}</p>
                    <div className='diagramm'>
                        <span className='x'/>
                        <span className='y'/>
                        <p className='y-text'>{t("cost")}</p>
                        <span className='graph china'/>
                        <span className='graph europe'/>
                        <p className='china-txt'>China</p>
                        <p className='europe-txt'>{t("europe")}</p>
                    </div>
                </div>

                <Seperator/>
            </section>

            <section className='info'>
                <div className='wrapper'>
                    <div className='container'>
                        <Package/>
                        <p>{t("package")}</p>
                    </div>

                    <div className='container'>
                        <p>{t("handshake")}</p>
                        <Handshake/>
                    </div>
                </div>

                <Seperator/>
            </section>

            <section className='promise'>
                <div className='wrapper'>
                    <Logo/>
                    <p className='text'>{t("promise")}</p>
                    <Button to="/contact" filled>{t("contact")}</Button>
                </div>
            </section>
        </div> 
    );
}
 
export default Distribution;